import css from '../../Approvals/css/view-modal.module.css'
//css/view-modal.module.css';
import {FaTimes as CancelIcon} from 'react-icons/fa';
import { styled } from '@mui/system';
import EachPersonalField from '../../ApplicantDetails/EachPersonField';
import { convertTimetoString } from '../../../../helperFunction';
import img from '../../../../images/default.png';
import TemplateSample from './TemplateSample';
import {useEffect} from 'react';


interface ViewApplicantDetailsProps {
    onChange: React.Dispatch<React.SetStateAction<boolean>>;
    data? : ApplicantDetails;
    showModal: boolean;
    showTemplate?:boolean;
    setShowTemplate :React.Dispatch<React.SetStateAction<boolean>>;
}


interface ApplicantDetails {
  ApplicantId: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  ContactAddress: string;
  Gender: string;
  Disablity?: any;
  IsSubmitted: boolean;
  RouteId: number;
  Title: string;
  BirthDate: string;
  WhatsAppNumber?: any;
  PhotoUrl: string;
  RouteName: string;
}


const ViewApplicantDetails: React.FC<ViewApplicantDetailsProps> = ({onChange, data, showModal,showTemplate,setShowTemplate}) => {

  useEffect(()=>{
    return ()=>{setShowTemplate(false);onChange(false)}
  },[])

    return(
        <>
          {
             showModal &&
             <SupperContainer >
                {!showTemplate ?
                <Container className={css.container}>
                    <span className={css.cancel} onClick={()=>onChange(false)}><CancelIcon /></span>
                    <div className={css.firstDiv}>
                        <div>
                        <img src={data?.PhotoUrl ? data?.PhotoUrl:img} style={{objectFit:"contain",width:"80px",borderRadius:"3px"}}/>
                        <div>
                            <span>
                                {`${data?.FirstName} ${data?.LastName}`}
                            </span>
                            <span style = {{fontSize: '20px'}}>{data?.ApplicantId}</span>
                            <span>{data?.RouteName}  Route</span>
                        </div>
                        </div>
                        <div>
                          {/* <span>Total Score</span>
                          <span> 0 /208 points</span> */}
                        </div>
                    </div>
                    <ContentDiv>
                    {data?.ApplicantId ?
                        <EachQualificationContainer>
                            <EachPersonalField label="Title" value={data?.Title || 'N/A'} />
                            <EachPersonalField label="First Name" value={data?.FirstName || 'N/A'} />
                            <EachPersonalField label="Middle Name" value={data?.MiddleName || 'N/A'} />
                            <EachPersonalField label="Surname Name" value={data?.LastName || 'N/A'} />
                            <EachPersonalField label="'Phone Number" value={data?.PhoneNumber || 'N/A'} />
                            <EachPersonalField label="WhatsApp Number" value={data?.WhatsAppNumber || 'N/A'} />
                            <EachPersonalField label="Date Of Birth" value={convertTimetoString(data?.BirthDate, 0) || 'N/A' } />
                            <EachPersonalField label="Email Address" value={data?.Email || 'N/A'} />
                            </EachQualificationContainer>
                        :'Not Available'}
                    </ContentDiv>
                </Container>:
                <TemplateSample />
                }
                <BackDrop onClick={()=>onChange(false)}/>
             </SupperContainer>

          } 
        </>
        
    )
}


export default ViewApplicantDetails;

const SupperContainer = styled('div')`
    display: flex;
    justify-content: center;
    width: 100%;
    height:100%;
    position: fixed;
    top:0;
    left:0;
    background-color: rgba(78, 83, 79, 0.5);
    z-index: 100;
    overflow: auto;

`

const BackDrop = styled('div')`
    
    width: 100%;
    height:100%;
    position: fixed;

`



const Container = styled('div')`
    width: fit-content;
    display: flex;
    flex-direction: column;
    background-color: var(--white-color);
    position: relative;
    z-index:100;
    top:50px;
    height: fit-content !important;
    width: 1158px;

`

const EachQualificationContainer = styled('div')`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  row-gap:20px;
  column-gap:10px;
  & > span{
    width: 100%;
  }
  & > span > span{
      padding:7px 10px;
      background-color:#E0FAEE;
      font-weight: 600;
  }
  & > div{
    width:40%;    
  }
`

const ContentDiv = styled('div')`
  padding-inline: 46px;
  padding-block: 20px 30px;
`